'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Entry;
(function (Entry) {
    var MyEntry = /** @class */ (function () {
        function MyEntry() {
            var self = this;
            $('.trigFileCheck').change(function (e) {
                var errorFlag = false;
                var errorMessage = '';
                var files = e.target.files;
                var file = files[0];
                var fileName = file.name;
                var fileSize = file.size;
                // 送れる大きさ(MB換算)
                var limitSize = 12 * 1000 * 1000;
                if (fileSize > limitSize) {
                    errorFlag = true;
                    errorMessage = 'ファイルアップロードの上限は12MBまでとなります。';
                }
                // 拡張子のチェック用配列
                var typeArray = ['doc', 'docx', 'xls', 'xlsx', 'pdf'];
                var fileStringArray = fileName.split('.');
                // 配列の最後の要素をlowercaseで取得
                var fileExtension = fileStringArray[fileStringArray.length - 1].toLowerCase();
                // 拡張子が設定している拡張子と一致するかチェック
                if (typeArray.indexOf(fileExtension) == -1) {
                    errorFlag = true;
                    errorMessage = '拡張子がアップロードに対応していないファイルです。';
                }
                if (errorFlag) {
                    alert(errorMessage);
                    $('.trigFileCheck').val('');
                }
            });
            $('#trigEntryForm').on('click', function () {
                $('.error').removeClass('error');
                $('.bulletError').hide();
                self.getValues();
                if (self.validates()) {
                    self.moveFormTop();
                    return false;
                }
            });
        }
        MyEntry.prototype.getValues = function () {
            this.name = $('#name').val();
            this.nameKana = $('#name_kana').val();
            this.sex = $('[name=sex]:checked').val();
            this.tel = $('#tel').val();
            this.email = $('#email').val();
            this.accept = $('[name=accept]:checked').val();
        };
        MyEntry.prototype.validates = function () {
            var errorFlag = false;
            this.errorName = "";
            if (!this.checkNull(this.name)) {
                errorFlag = true;
                $('#name').addClass('error');
                $('#error_name').show();
                this.errorName = 'paramFormName';
            }
            if (!this.checkNull(this.nameKana)) {
                errorFlag = true;
                $('#name_kana').addClass('error');
                $('#error_name_kana').show();
                if (this.errorName == "") {
                    this.errorName = 'paramFormNameKana';
                }
            }
            if (!this.checkNull(this.sex)) {
                errorFlag = true;
                $('#error_sex').show();
                if (this.errorName == "") {
                    this.errorName = 'paramFormSex';
                }
            }
            if (!this.checkNull(this.tel)) {
                errorFlag = true;
                $('#tel').addClass('error');
                $('#error_tel').show();
                if (this.errorName == "") {
                    this.errorName = 'paramFormTel';
                }
            }
            else if (!this.telFormatCheck(this.tel)) {
                errorFlag = true;
                $('#tel').addClass('error');
                $('#error_tel_format').show();
                if (this.errorName == "") {
                    this.errorName = 'paramFormTel';
                }
            }
            if (!this.checkNull(this.email)) {
                errorFlag = true;
                $('#email').addClass('error');
                $('#error_email').show();
                if (this.errorName == "") {
                    this.errorName = 'paramFormMail';
                }
            }
            else if (!this.emailFormatCheck(this.email)) {
                errorFlag = true;
                $('#email').addClass('error');
                $('#error_email_format').show();
                if (this.errorName == "") {
                    this.errorName = 'paramFormMail';
                }
            }
            if (!this.checkNull(this.accept)) {
                errorFlag = true;
                $('#error_accept').show();
                if (this.errorName == "") {
                    this.errorName = 'paramFormAccept';
                }
            }
            return errorFlag;
        };
        MyEntry.prototype.moveFormTop = function () {
            var headerHeight = $('#header').outerHeight();
            var formPosition = $('.' + this.errorName).offset().top;
            $('html, body').animate({
                scrollTop: formPosition - headerHeight
            }, 'slow');
        };
        MyEntry.prototype.checkNull = function (val) {
            return this.removeSpace(val) != '';
        };
        // 空白文字の削除
        MyEntry.prototype.removeSpace = function (val) {
            if (val) {
                return val.replace(/\s+/g, '');
            }
            else {
                return '';
            }
        };
        // 電話番号のフォーマットチェック
        MyEntry.prototype.telFormatCheck = function (val) {
            return val.match(/[0-9]{2,4}[\-]{0,1}[0-9]{2,4}[\-]{0,1}[0-9]{2,4}/);
        };
        // メールのフォーマットチェック
        MyEntry.prototype.emailFormatCheck = function (val) {
            return val.match(/^[0-9a-zA-Z]+[0-9a-zA-Z\-\+_\.]+@[0-9a-zA-Z\-\+_\.]+\.[0-9a-zA-Z\-\+_\.]+$/g);
        };
        return MyEntry;
    }());
    Entry.MyEntry = MyEntry;
})(Entry || (Entry = {}));
exports.default = Entry;
